import { createStyles } from 'antd-style';

const useStyles = createStyles(() => {
  return {
    footerContainer: {
      'display': 'flex',
      'color': 'white',
      'gap': 10,
      'flexWrap': 'wrap',
      'margin': '0 10px',
      '@media (max-width: 730px)': {
        justifyContent: 'center',
      },
    },
  };
});

export default useStyles;
